/**
 *
 * Planner
 *
 */

import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Card } from 'react-bootstrap';
import Spinner from 'components/Spinner/index.jsx';
import VideoConfProvider from 'components/VideoConf/Loadable.js';
import useWizard from 'utils/useWizard.jsx';
import { idValues } from 'utils/arrays.js';
import getMeetingSteps from './getMeetingSteps.js';

function Planner(props) {
  const { group, meetingSets, groupId } = props;
  const { mid } = useParams();
  const setId = Number(mid);
  const meetingSet = useMemo(() => meetingSets[setId] || {}, [meetingSets, setId]);
  const navigate = useNavigate();
  const meetingList = useMemo(() => idValues(meetingSet.meetings), [meetingSet.meetings]);
  const steps = useMemo(() => getMeetingSteps(meetingSet), [meetingSet]);
  const { activeStep, StepNav, setActive } = useWizard(steps, 'step');
  const currentStep = steps[activeStep - 1] || steps[0];
  const loading = !group.students || group.students.loading || (meetingSet.meetings?.working) || (activeStep > 1 && !setId);

  const Component = currentStep.component;
  const header = currentStep.header || currentStep.label;
  const handleClose = useCallback(() => {
    navigate(`/groups/${groupId}/meetings`);
  }, [groupId, navigate]);
  const handleNext = useCallback(() => {
    if (activeStep < steps.length) {
      setActive(activeStep + 1);
    }
  }, [activeStep, setActive, steps]);

  if (meetingSets.loading || loading) {
    return <Spinner />;
  }
  if (meetingSets.error) {
    return <span>ERROR</span>;
  }

  return (
    <VideoConfProvider>
      <Card>
        <StepNav />
        <Card.Body>
          <h3 className="mb-4">
            {`${activeStep}. `}
            <FormattedMessage {...header} />
          </h3>
          <Component
            {...props}
            meetingSet={meetingSet}
            meetingList={meetingList}
            onClose={handleClose}
            onNext={handleNext}
          />
        </Card.Body>
      </Card>
    </VideoConfProvider>
  );
}

Planner.propTypes = {
  group: PropTypes.object,
  groupId: PropTypes.number,
  setId: PropTypes.number,
  meetingSets: PropTypes.object,
};

export default Planner;
